import { imagesAssets } from "../assets/images";

export const user = [
  {
    name: "Plans",
    path: "/plans",
    activeIcon: imagesAssets.personalCardActive,
    icon: imagesAssets.personalCard,
  },
  {
    name: "My Business",
    path: "/mybusiness",
    activeIcon: imagesAssets.profileActive,
    icon: imagesAssets.profile,
  },
  {
    name: "Manage Subscriptions",
    path: "/managesubscriptions",
    activeIcon: imagesAssets.manageSubscriptionsActive,
    icon: imagesAssets.manageSubscriptions,
  },
  {
    name: "Setting",
    path: "/setting",
    activeIcon: imagesAssets.settingActive,
    icon: imagesAssets.setting,
  },
];
